import { render, staticRenderFns } from "./TiEvents.vue?vue&type=template&id=5f1a8a16"
import script from "./TiEvents.vue?vue&type=script&lang=js"
export * from "./TiEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports